import { AdminIntroductions } from '@platform/client';
import { useParams } from 'wouter';
import { AdminDetailPage } from '../../AdminDetailPage';
import { DetailsTabContent } from './DetailsTabContent';
import { ProjectPlanTabContent } from './ProjectPlanTabContent';
import { DiscoveryUpdatesTabContent } from './DiscoveryUpdatesTabContent';
import { IntroEmailTabContent } from './EmailTabContent';

export const IntroductionDetail = () => {
  const { introductionId } = useParams<{ introductionId: string }>();
  const {
    data: introData,
    isLoading,
    isSuccess,
  } = AdminIntroductions.useGetIntroductionById(parseInt(introductionId));

  return (
    <>
      <AdminDetailPage
        title={
          introData?.introduction?.id ?
            `Introduction #${introData.introduction.id}`
          : 'Introduction Details'
        }
        isLoading={isLoading}
        isSuccess={isSuccess}
        tabs={[
          {
            id: 'Details',
            content: <DetailsTabContent introData={introData?.introduction} />,
          },
          {
            id: 'Discovery Updates',
            content: <DiscoveryUpdatesTabContent updatesData={introData?.discoveryUpdates} />,
          },
          {
            id: 'Project Plan',
            content: <ProjectPlanTabContent planData={introData?.projectPlan} />,
          },
          {
            id: 'Emails',
            content: <IntroEmailTabContent introId={parseInt(introductionId)} />,
          },
        ]}
        pageActions={[
          {
            text: 'Edit',
            href: `/${introductionId}/edit`,
            type: 'link',
          },
        ]}
      />
    </>
  );
};
